import { axios } from "@/client/libs/axios";
import { CreateCreditDto, MessageDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export const createCredit = async (data: CreateCreditDto) => {
  const response = await axios.post<MessageDto, AxiosResponse<MessageDto>>("/credit", data);
  return response.data;
};

export const useCreateCredit = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: createCreditFn,
  } = useMutation({
    mutationFn: (data: CreateCreditDto) => createCredit(data),
  });

  return { addCredit: createCreditFn, loading, error };
};
